import axios from "axios";
import { decrypt, closeModalGoHome } from "../../../modules/login";

// Acessors
const getAccountUsername = (state) => decrypt(state?.loginReducer.username);

const initialState = {};

export const noticeReducer = (state = initialState, action) => {
  return state;
};

export const handleAcceptedTerms =
  (username, acceptTerms) => async (dispatch, getState) => {
    try {
      await axios.post(`/api/participant/accepttermsandconditions`, {
        Username: username,
        AcceptTerms: acceptTerms,
      });
    } catch (error) {
      return Promise.reject(error);
    }
    return Promise.resolve();
  };

export const mapStateToProps = (state) => {
  return {
    accountUsername: getAccountUsername(state),
  };
};

export const mapDispatchToProps = {
  closeModalGoHome,
  handleAcceptedTerms,
};
